import { Link } from '@superlogica/button'
import { rem } from 'polished'
import styled from 'styled-components'

import media from '../../../utils/media'
import ConversionBox from '../../ConversionBox'
import { AccordionItem } from '../Accordion'

export const FooterWrapper = styled.footer`
  padding-top: ${({ withCta }) => (withCta ? 0 : 80)}px;
  background-color: ${({ theme }) => theme.color.white};

  ${media.lessThan('sm')`
    padding-top: 80px;
  `}
`

export const FooterConversion = styled(ConversionBox)`
  ${media.greaterThan('sm')`
    transform: translateY(-50%);
  `}
`

export const FooterBrand = styled.div`
  flex-shrink: 0;

  ${media.greaterThan('md')`
    margin-right: 88px;
  `}

  ${media.lessThan('md')`
    margin-bottom: 32px;
  `}
`

export const FooterNav = styled.nav`
  display: flex;
  justify-content: space-between;
  width: 100%;

  ${media.lessThan('sm')`
    flex-direction: column;
  `}
`

export const FooterNavCol = styled.div`
  flex-shrink: 0;

  ${media.greaterThan('sm')`
    &:not(:first-of-type) {
      margin-left: 32px;
    }
  `}
`

export const FooterAccordion = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  flex-shrink: 0;

  ${media.lessThan('sm')`
    flex-direction: column;
  `}
`

export const FooterAccordionItem = styled(AccordionItem)`
  .accordion__title {
    display: inline-block;
    color: ${({ theme }) => theme.color.neutral900};
    font-size: ${rem(14)};
    font-weight: 700;
    text-transform: uppercase;
  }

  ${media.greaterThan('sm')`
    .accordion__heading {
      margin-bottom: 24px;
    }

    .accordion__chevron {
      display: none;
    }
  `}

  ${media.lessThan('sm')`
    border-bottom: 1px solid ${({ theme }) => theme.color.neutral300};

    .accordion__heading {
      padding-top: 16px;
      padding-bottom: 16px;
    }
  `}
`

export const FooterMenu = styled.ul``

export const FooterNavItem = styled.li``

export const FooterNavLink = styled(Link)`
  flex-shrink: 0;
  font-weight: normal;
`

export const FooterText = styled.p`
  font-size: ${rem(12)};

  ${media.lessThan('lg')`
    br {
      display: none;
    }
  `}
`

export const FooterContent = styled.div`
  display: flex;

  ${FooterNavItem} {
    margin-bottom: 8px;
  }

  ${media.greaterThan('sm')`
    ${FooterMenu} {
      margin-bottom: 48px;
    }
  `}

  ${media.lessThan('md')`
    flex-direction: column;
  `}

  ${media.lessThan('sm')`
    margin-bottom: 32px;

    ${FooterNavItem} {
      &:last-of-type {
        margin-bottom: 16px;
      }
    }
  `}
`

export const FooterJuridic = styled.div``

export const FooterJuridicBar = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 16px;
  padding-top: 16px;
  padding-bottom: 32px;

  ${media.between('sm', 'lg')`
    ${FooterText} {
      max-width: 420px;
    }
  `}

  ${media.greaterThan('sm')`
    border-top: 1px solid ${({ theme }) => theme.color.neutral300};
  `}

  ${media.lessThan('sm')`
    flex-direction: column-reverse;
  `}
`

export const FooterJuridicMenu = styled.div`
  ${FooterMenu} {
    display: flex;
  }

  ${FooterNavLink} {
    font-weight: 700;
    font-size: ${rem(12)};
  }

  ${media.greaterThan('sm')`
    ${FooterNavItem} {
      display: flex;
      align-items: center;

      &:not(:last-of-type) {
        &:after {
          content: '';
          width: 2px;
          height: 12px;
          display: block;
          background-color: ${({ theme }) => theme.color.neutral300};
          margin-left: 16px;
          margin-right: 16px;
          display: inline-block;
        }
      }
    }
  `}

  ${media.lessThan('sm')`
    ${FooterMenu} {
      flex-direction: column;
      border-bottom: 1px solid ${({ theme }) => theme.color.neutral300};
      padding-bottom: 16px;
      margin-bottom: 16px;
    }
  `}
`
